import type { Operateur } from '@/types/Contenu'

// Couleur de la pastille de chaque opérateur Mobile Money (modale des dons).
export const OPERATEURS: Record<Operateur, { libelle: string; badgeClass: string }> = {
  airtel: { libelle: 'Airtel Money', badgeClass: 'bg-red-600' },
  orange: { libelle: 'Orange Money', badgeClass: 'bg-orange-500' },
  mpesa: { libelle: 'M-Pesa', badgeClass: 'bg-green-600' },
  autre: { libelle: 'Autre', badgeClass: 'bg-cmp-navy' },
}
